<template>
    <div class="navbar-component">
        <CategoriesComponent v-model="selectedCategories" />
        <div class="nav-actions-component">
            <ThemeSwitcherIcon @click="useThemeStore.toggle()" />
            <p @click="goAbout" class="cursor-pointer">about</p>
            <LiquidTrademarkIcon />
        </div>
    </div>
</template>

<style scoped>
.navbar-component {
    display: flex;
    width: 100%;
    height: var(--navbar-height);
    align-items: center;
    justify-content: space-between;
    touch-action: none;
}

.nav-actions-component {
    display: flex;
    gap: 40px;
    letter-spacing: var(--action-letter-spacing);
}

@media (max-width: 996px) {
    .nav-actions-component {
        display: none;
    }
}

.nav-actions-component p {
    font-size: 18px;
    margin-top: 3px;
}

@media (max-width: 1400px) {
    .nav-actions-component {
        gap: 55px;
    }
}

@media (min-width: 1401px) {
    .nav-actions-component {
        gap: 73px;
    }
}

</style>

<script setup>
import { ref, watch } from 'vue';
import { useThemeStore } from '@/stores/useThemeStore';
import CategoriesComponent from '../molecules/categories-component.vue';
import ThemeSwitcherIcon from '../atoms/theme-switcher-icon.vue';
import LiquidTrademarkIcon from '../atoms/liquid-trademark-icon.vue';
import { useRouter } from 'vue-router';

const selectedCategories = ref([])

const emit = defineEmits(['selected'])

const router = useRouter()

watch(selectedCategories, (categoriesValue) => emit('selected', categoriesValue))

function goAbout() {
    router.push('/about')
}
</script>
